import { useQueryClient } from '@tanstack/react-query';
import logger from '@utils/logger';
import { usePublishZoneMutation } from 'src/graphql/generated/graphql';

const usePublishZone = () => {
  const queryClient = useQueryClient();
  const { mutate, mutateAsync, isError, isLoading, isSuccess, data } = usePublishZoneMutation({
    onError: (error) => {
      let loggedError: Error = Error('publishZone failed');
      if (error instanceof Error) {
        loggedError = error;
      }
      void logger.error('Call to publishZone resulted in error', loggedError);
    },
    onSuccess: (response, variables) => {
      const { error } = response.publishZone;
      if (error) {
        void logger.error('Call to publishZone resulted in error', error);
      } else {
        void queryClient.invalidateQueries([
          'getMacroplanogram',
          {
            input: {
              includeFuture: false,
              storeId: variables.input?.storeId,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              timestamp: variables.input?.timestamp,
            },
          },
        ]);
      }
    },
  });

  const { error } = data?.publishZone ?? {};
  return {
    mutate,
    mutateAsync,
    isError,
    isLoading,
    isSuccess,
    error,
  };
};

export default usePublishZone;
